import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import classNames from "classnames";
import TextTruncate from "components/TextTruncate";
import SimpleRemoveButton from "components/SimpleRemoveButton";
import AlternativeStepParamConfig from "./components/AlternativeStepParamConfig";
import CellModelRecipeParamConfig from "./components/CellModelRecipeParamConfig";
import { OptimizationParameterParameterType, } from "store/rs-workspace/rs-workspace.types";
import { setDeleteTarget } from "store/knowledge-base-item/knowledge-base-item.actions";
import { RemovableEntityType } from "store/knowledge-base-item/knowledge-base-item.types";
import { isEditableSelector } from "store/knowledge-base-item/knowledge-base-item.selectors";
import { isNotEmpty } from "utils/validate";
import * as styles from "./styles.module.scss";
const ParameterCard = ({ index, name, parameter, restrictions, removeAction, removeWithConfirmation, }) => {
    const dispatch = useDispatch();
    const editable = useSelector(isEditableSelector);
    const setInputSetDeleteTarget = useCallback((index) => {
        dispatch(setDeleteTarget({
            id: index,
            type: RemovableEntityType.OPTIMIZATION_PARAMETER,
        }));
    }, [dispatch]);
    return (React.createElement("div", { className: styles["parameter"] },
        React.createElement("div", { className: styles.header },
            React.createElement(TextTruncate, { text: parameter?.name, className: classNames(styles["parameter-name"], {
                    [styles.accented]: parameter.type === OptimizationParameterParameterType.CELL_MODEL_OR_RECIPE &&
                        !isNotEmpty(parameter?.value, true),
                }) })),
        parameter.type === OptimizationParameterParameterType.CELL_MODEL_OR_RECIPE ? (React.createElement(CellModelRecipeParamConfig, { parameter: parameter, name: name, restrictions: restrictions?.CellModelOrRecipe, editable: editable })) : (React.createElement(AlternativeStepParamConfig, { parameter: parameter, name: name, editable: editable, restrictions: restrictions?.AlternativeFlow })),
        editable && (React.createElement(SimpleRemoveButton, { className: styles["delete-icon"], onOpen: () => setInputSetDeleteTarget(index), action: removeAction, isMenuItem: false, withConfirmation: removeWithConfirmation }))));
};
export default ParameterCard;
